interface ForbiddenPageProps {
  title?: string;
  message?: string;
}

/** Friendly notice shown when the API answers 403/404 on a role-scoped route. */
export function ForbiddenPage({
  title = 'No access',
  message = "You don't have permission to view this page.",
}: ForbiddenPageProps) {
  return (
    <div className="bg-bg-panel border border-border rounded-xl p-8 text-center max-w-2xl mx-auto">
      <h1 className="text-lg font-semibold text-white">{title}</h1>
      <p className="text-sm text-muted mt-2">{message}</p>
    </div>
  );
}
